import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  AdahiAccordionComponent } from '../components/accordion.component';


@NgModule({
  declarations: [
    AdahiAccordionComponent
  ],
  imports:[
    CommonModule
  ],
  exports:[
    AdahiAccordionComponent
  ]
})
export class AdahiAccordionModule { }
